interface PortalConfig {
  googleClientId: string;
  apiBase: string;
  allowedHostedDomains: string[];
}

function read(): PortalConfig {
  const d = document.documentElement.dataset;
  const googleClientId = d.googleClientId ?? '';
  const apiBase = d.apiUrl ?? '';
  const allowedHdRaw = d.allowedHd ?? '';
  if (!googleClientId || !apiBase || !allowedHdRaw) {
    throw new Error('Portal config missing — index.html was not configured at deploy time. Re-run cdk deploy VinzPortal.');
  }
  const allowedHostedDomains = allowedHdRaw.split(',').map((s) => s.trim()).filter(Boolean);
  return { googleClientId, apiBase, allowedHostedDomains };
}

export const portalConfig: PortalConfig = read();
